import motor from "./IMG-activityPH_motor.png";
import selfRegulation from "./IMG-activityPH_selfregulation.png";
import cognitive from "./IMG-activityPH_cognitive.png";
import sensory from "./IMG-activityPH_sensory.png";
import interactive from "./IMG-activityPH_interactive.png";

// Imagen de la ficha por activity_types.id. Es la que se ve mientras la
// actividad no tenga image_url propia, que hoy no tiene ninguna.
const activityCardImages = {
  1: motor,
  2: selfRegulation,
  3: cognitive,
  4: sensory,
  5: interactive,
};

export default activityCardImages;
